import { render, staticRenderFns } from "./ChevronsRight.vue?vue&type=template&id=ebbaac84&scoped=true&"
import script from "./ChevronsRight.vue?vue&type=script&lang=js&"
export * from "./ChevronsRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbaac84",
  null
  
)

export default component.exports